import Mock from "mockjs";
import { isSSR } from "@/utils/is";
import setupMock from "@/utils/setupMock";

const getMockAuthorities = role => {
  if (role === "admin") {
    return ["sys:user:list", "sys:user:add", "sys:user:edit", "sys:user:delete", "sys:user:import", "sys:user:export", "sys:menu:list", "sys:role:list", "sys:loginlog:list", "sys:operlog:list", "sys:config:list"];
  }

  return ["sys:user:list"];
};

const mockMenus = [{
  title: "仪表盘",
  path: "/dashboard",
  children: [{
    title: "工作台",
    path: "/dashboard/workplace",
    component: "dashboard/workplace"
  }]
}, {
  title: "CDK 管理",
  path: "/cdk",
  children: [{
    title: "CDK 列表",
    path: "/cdk/index",
    component: "cdk/index"
  }, {
    title: "盒子激活管理",
    path: "/box/index",
    component: "box/index"
  }]
}, {
  title: "游戏管理",
  path: "/game",
  children: [{
    title: "游戏列表",
    path: "/game/index",
    component: "game/index"
  }]
}, {
  title: "系统管理",
  path: "/system",
  icon: "el-icon-setting",
  children: [{
    title: "用户管理",
    path: "/system/user-management",
    component: "system/user-management",
    icon: "el-icon-user"
  }, {
    title: "菜单管理",
    path: "/system/menu-management",
    component: "system/menu-management",
    icon: "el-icon-menu"
  }, {
    title: "角色管理",
    path: "/system/role",
    component: "system/role",
    icon: "el-icon-s-custom"
  }, {
    title: "登录日志",
    path: "/system/loginlog",
    component: "system/loginlog",
    icon: "el-icon-time"
  }, {
    title: "操作日志",
    path: "/system/operlog",
    component: "system/operlog",
    icon: "el-icon-document"
  }]
}, {
  title: "系统配置",
  path: "/config",
  children: [{
    title: "站点配置",
    path: "/config/website",
    component: "config/website"
  }]
}, {
  title: "个人中心",
  path: "/user",
  children: [{
    title: "个人信息",
    path: "/user/profile",
    component: "user/profile"
  }]
}];

if (!isSSR) {
  Mock.XHR.prototype.withCredentials = true;
  setupMock({
    setup: () => {
      const userRole = window.localStorage.getItem("userRole") || "admin";
      Mock.mock(new RegExp("/api/user/userInfo"), () => {
        const authorities = getMockAuthorities(userRole);
        return Mock.mock({
          name: "admin",
          avatar: "https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png",
          email: "wangliqun@email.com",
          job: "frontend",
          jobName: "前端开发工程师",
          organization: "Frontend",
          organizationName: "前端",
          location: "beijing",
          locationName: "北京",
          introduction: "王力群并非是一个真实存在的人。",
          personalWebsite: "https://www.arco.design",
          verified: true,
          phoneNumber: /177[*]{6}[0-9]{2}/,
          accountId: /[a-z]{4}[-][0-9]{8}/,
          registrationTime: Mock.Random.datetime("yyyy-MM-dd HH:mm:ss"),
          authorities
        });
      });
      Mock.mock(new RegExp("/menu/getList"), () => mockMenus);
      Mock.mock(new RegExp("/api/user/login"), params => {
        const {
          userName,
          password
        } = JSON.parse(params.body);

        if (!userName) {
          return {
            status: "error",
            msg: "用户名不能为空"
          };
        }

        if (!password) {
          return {
            status: "error",
            msg: "密码不能为空"
          };
        }

        if (userName === "admin" && password === "admin") {
          return {
            status: "ok"
          };
        }

        return {
          status: "error",
          msg: "账号或者密码错误"
        };
      });
    }
  });
}